import "./extension-edit"
import { Box } from "@mui/material"
import { Secure } from "lib/authorization/secure"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { RegimeToolbar, ScheduleSelectorToolbar } from "slot-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { PlanRoot } from "library/tree/constants.mjs"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { Activity } from "routes/audit/component/activity-button"

ScheduleSelectorToolbar("myTree").plug(replaceAllWith(<Frag />, 1000))
RegimeToolbar.plug(<RegimeOptions priority={2500} />)

function RegimeOptions() {
    const { parentItem } = useBoundContext()

    return (
        <>
            {parentItem[PlanRoot] && (
                <Box ml={1}>
                    <Activity
                        type={"maintenanceRegime"}
                        passedId={parentItem.id}
                        fileNamePrefix={parentItem.$.name.split(" ").join("-")}
                        pageSize={50}
                    />
                </Box>
            )}
            <Secure hide demand="manageRegime" fallback={<Frag />}>
                <ContextMenuBar type="folder" />
            </Secure>
        </>
    )
}
